module.exports = __webpack_public_path__ + "static/media/Musitude-Logo-RGB-Strap-R-compressor.f5d2d60d.jpg";